import React, { useState, useEffect} from 'react';
import { POST_RX_ORDER_URL } from './types';
import { useProduct } from '@src/components/ProductProvider';
import { RxSiteBody } from './RxSiteForm';
import { CartProvider, useCart } from '@src/components/CartProvider';
import { ImageGallery } from '@shared_components/components/ImageGallery';
import { HandleAxios } from '@shared_components/components/requests/HandleAxios';
import { useMessage } from '@shared_components/providers/MessageProvider';  




export const RxSiteViewHandler = () => {
    const { loading, error, product } = useProduct();
    const { values } = useCart()
    const [formLoading, setFormLoading] = useState<boolean>(false);
    const { setTextData } = useMessage();
    const [files, setFiles] = useState<File[]>([]);

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (formLoading) return; // Prevent multiple submissions
        if (!product || !product.variant || product.variant.length === 0) {
            setTextData({
                variant: "danger",
                text: "Product not found or no variants available.",
            });
            return;
        }
        const handleComplete = (response: any) => {
            setFormLoading(false);
            if (response && response?.data && response?.data?.data) {
                // go to invoice url
                window.location.href = response.data.data;
            } else {
                setTextData({
                    variant: "danger",
                    text: "An error occurred while processing your order.",
                });
                return;
            }
            // Handle success response here
        }
        const handleError = (error: any) => {
            setFormLoading(false);
            const errorMessage = typeof error === "string" ? error : "An error occurred while submitting the form.";
            setTextData({ variant: "danger",text: errorMessage  });
            // Handle error response here
        }
        const formData = new FormData();
        // // Append all values to formData
        formData.append("email", values.email);
        formData.append("discount_code", values.discountCode);
        formData.append("qty", values.qty.toString());
        const items = []
        for (let i = 0; i < values.itemLines.length; i++) {
            const item = { 
                "name": values.itemLines[i].name,
                "item_id": product?.variant[0].variant_id,
                "inputs": JSON.stringify(values.itemLines[i].inputs)
            }
            items.push(item);
        }
        formData.append("items", JSON.stringify(items));
        files.forEach((file, index) => {
            formData.append('files_'+index, file); // Use the same field name ('files') for all files
        });
        setFormLoading(true);

        HandleAxios({
            url: POST_RX_ORDER_URL,
            method: "post",
            data: formData,
            onComplete: handleComplete,
            onError: handleError,
            contentType: "multipart/form-data",
        })
    }



    if (error) {
        return (
            <div className="flex flex-col w-full h-full ">
                <h2 className="text-red-500">Error loading page</h2>
                <p>Please try again later!</p>

            </div>
        )
    }

    return (
            <div className="flex flex-col w-full h-full ">
                {!loading && product && (
                    <div className="flex flex-col w-full h-full  ">
                        <div className="min-h-screen flex flex-col items-center justify-center  ">
                            <div className="w-full max-w-3xl lg:max-w-4xl bg-gray-200 md:p-20 sm:p-2 rounded-lg shadow-lg flex flex-col gap-2">

                                <h2 className="text-3xl sm:text-4xl font-extrabold text-center text-gray-900 mb-8 md:mt-0 mt-4">
                                    ZERO RX LENS INSERT
                                </h2>
                                <div className="bg-white p-6 sm:p-8 rounded-xl shadow-2xl space-y-8">
                                    <ImageGallery
                                        images={product.image}
                                        fullImageKey='image_data'
                                        thumbnailImageKey="thumbnail_data"
                                        backgroundColor='bg-white'
                                    />
                                </div>
                                <form className="bg-white p-6 sm:p-8 rounded-xl shadow-2xl space-y-8"   onSubmit={handleSubmit}>
                                    <RxSiteBody
                                        product={product}
                                        loading={formLoading}
                                        files={files}
                                        setFiles={setFiles}
                                    />
                                </form>

                            </div>
                        </div>
                    </div>
                )}

            </div>
    )
}
